import axios from "axios";
import { newAbortSignal } from "../../utils";
import { SessionStore } from "../../types/store/SessionStore";
import { UpdateUserPasswordRequest } from "../../types/interfaces/user";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/account`;

export const updateUserPassword = async (
  accountId: number,
  userId: number,
  passwordData: UpdateUserPasswordRequest
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}"
  );

  const finalURL = `${BASE_URL}/${accountId}/user/${userId}/password`; 

  return await axios
    .put<void>(finalURL, passwordData, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        typeof AbortSignal.timeout !== "undefined"
          ? AbortSignal.timeout(
              parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)
            )
          : newAbortSignal(parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
    })
    .then((response) => response.data);
};
